import React from 'react';
import { Redirect, Route, useLocation } from 'react-router-dom';

import { useAuthenticationState } from '../../libs/IdeLink.Web.Common/src/Hooks/useAppState';
import { AuthModule } from '../../libs/IdeLink.Web.Common/src/modules/Auth/AuthModule';
import { RouteItemProps } from '../../libs/IdeLink.Web.Common/src/types/RouteItem';

export const PrivateRoute = ({
    component: TargetComponent,
    hasAccess = () => true,
    ...rest
}: RouteItemProps) => {
    const location: string = useLocation().pathname;
    const isAuthenticated = useAuthenticationState().get('isAuthenticated');

    return (
        <Route
            {...rest}
            render={() => {
                if (isAuthenticated && hasAccess()) {
                    return TargetComponent ? <TargetComponent {...rest} /> : null;
                }
                if (isAuthenticated && !hasAccess()) {
                    return <Redirect to={{ pathname: '/403', state: { from: location } }} />;
                }
                return (
                    <Redirect to={{ pathname: AuthModule.AUTH_LOGIN, state: { from: location } }} />
                );
            }}
        />
    );
};
